import INTEGRATION_LOGO from "../assets/people-pension-logo.svg";

const INTEGRATION_NAME = "People's Pension";
const INTEGRATION_TYPE = "pension";
const INTEGRATION_VARIABLE = "peoplesPension";
const INTEGRATION_IN_PROGRESS = false;

export { INTEGRATION_NAME, INTEGRATION_TYPE, INTEGRATION_VARIABLE, INTEGRATION_LOGO, INTEGRATION_IN_PROGRESS };